// import { SpoStatus } from '@constants'
import SpoEnquiryItem from './SpoEnquiryItem'

const { Record, List } = require('immutable')

const SpoRecord = Record({
	access_type: null,
	billing_address: null,
	created_at: null,
	created_by: null,
	consignee: null,
	dispatch_location: null,
	dispatch_start_date: null,
	enquiry_ids: null,
	estimate_pdf_id: null,
	expected_delivery_date: null,
	id: null,
	logistics_quote_per_mt: null,
	lumpsum_logistics_quote: null,
	mbook_billing_address: null,
	message: null,
	minimum_guaranteed_weight: null,
	minimum_order_quantity: null,
	oracle_id: null,
	order_ids: null,
	order_items: new List(),
	order_in_kgs: null,
	order_details: null,
	original_supplier_po_number: null,
	other_charges: null,
	payment_terms_list: null,
	platform: null,
	quote_type: 'FOR',
	region: null,
	shipping_address: null,
	supplier: null,
	supplier_invoices: null,
	supplier_po_amount: null,
	supplier_po_date: new Date().getTime(),
	supplier_po_documents: null,
	supplier_po_number: null,
	supplier_po_status: null,
	tax_details: null,
	terms: `We declare that this invoice shows the actual price of the goods and all the particulars are true and correct.\n1. Interest upto 24% p.a. will be charged after a grace period of 7 days if the payment is not received as per the payment terms.\n2. Risk is transferred on delivery of goods to the party.\n3. All disputes are subject to Delhi Jurisdiction only.\n4. Weight Tolerance :- +/- 0.5% OF Invoiced Weight Visit www.metalbook.app / Download Metalbook app (Download App) to track your current order, see past invoices and orders with Metalbook, ledger and other details. COMPANY'S BANK DETAILS BANK NAME : Standard Chartered Bank A/C NO : 53105141407 IFSC CODE : SCBL0036025`,

	// terms: '1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n',
	updated_at: null,
	updated_by: null,
	// added keys
	oracle_error: null,
	expected_transit_time: null,
	supply_margin: null,
	added_through_spo: null,
	delivery_region: null,
	supply_managers: null,
})

class Spo extends SpoRecord {
	constructor(data) {
		super({
			...data,
			order_items: List(data?.order_items?.map((item) => new SpoEnquiryItem(item))),
		})
	}

	update(updates) {
		return this.merge(updates)
	}

	addNewItem(newItem) {
		return this.merge({
			order_items: this.order_items?.push(newItem),
		})
	}

	deleteItem(itemId) {
		const itemIndex = this.order_items.findIndex((_i) => _i.item_id === itemId)
		if (itemIndex > -1) {
			return this.merge({
				order_items: this.order_items.delete(itemIndex),
			})
		}
		return this
	}
	updateItem(itemId, data) {
		const itemIndex = this.order_items.findIndex((_i) => _i.item_id === itemId)
		if (itemIndex > -1) {
			return this.merge({
				order_items: this.order_items.set(itemIndex, data),
			})
		}
		return this
	}
}

export default Spo
